// extracted by mini-css-extract-plugin
export default {"linkText":"v4_MHzjgtmg0kz281VtR","linkIcon":"Af8hCLNfTF4ndhqVlnVQ"};